<div class="card">
  <rqa-page-title [title]="'groups.title' | translate">
    <p-button icon="pi pi-plus" [label]="'groups.form.add' | translate" class="p-button-sm" (click)="openAddGroup()" />
  </rqa-page-title>
  <p-table
    #groupsTable
    [value]="groups()"
    [scrollable]="true"
    [scrollHeight]="tableScrollHeight()"
    dataKey="id"
    [globalFilterFields]="['name', 'groupValue', 'creationDate', 'responsibleUnit', 'usersCount']"
    styleClass="p-datatable-sm"
    [loading]="loading()"
  >
    <ng-template #caption>
      <div class="flex">
        <p-iconfield iconPosition="left">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            pInputText
            type="text"
            (input)="filterGroups($event, 'contains')"
            [placeholder]="'groups.search' | translate"
          />
        </p-iconfield>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{ 'groups.table.header.name' | translate }} <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="groupValue">
          {{ 'groups.table.header.type' | translate }} <p-sortIcon field="groupValue"></p-sortIcon>
        </th>
        <th pSortableColumn="creationDate">
          {{ 'groups.table.header.creationDate' | translate }} <p-sortIcon field="creationDate"></p-sortIcon>
        </th>
        <th pSortableColumn="responsibleUnit">
          {{ 'groups.table.header.responsibleUnit' | translate }} <p-sortIcon field="responsibleUnit"></p-sortIcon>
        </th>
        <th pSortableColumn="usersCount">
          {{ 'groups.table.header.usersCount' | translate }} <p-sortIcon field="usersCount"></p-sortIcon>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-group let-expanded="expanded">
      <tr>
        <td>{{ group.name }}</td>
        <td>{{ group.groupValue }}</td>
        <td>{{ group.creationDate | date: 'dd.MM.yyyy' }}</td>
        <td>{{ group.responsibleUnit }}</td>
        <td>{{ group.usersCount }}</td>
        <td>
          <button
            pButton
            type="button"
            [icon]="isGroupExpanded(group.id) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            class="p-button-text p-button-rounded p-button-plain"
            (click)="toggleGroupExpansion(group)"
          ></button>
          <button
            pButton
            type="button"
            [icon]="'pi pi-pencil'"
            class="p-button-text p-button-rounded p-button-plain"
            (click)="openEditGroup(group)"
          ></button>
          <button
            pButton
            type="button"
            [icon]="'pi pi-trash'"
            class="p-button-text p-button-rounded p-button-plain"
            (click)="openDeleteGroup(group)"
          ></button>
        </td>
      </tr>

      <!-- Expanded row for group users -->
      <tr *ngIf="isGroupExpanded(group.id)">
        <td colspan="6" class="p-0 bg-gray-50">
          <p-table
            #groupUsersTable
            [value]="group.webRqaUsers"
            [scrollable]="true"
            scrollHeight="300px"
            dataKey="username"
            [globalFilterFields]="['username', 'firstName', 'lastName', 'role']"
            styleClass="p-datatable-sm"
          >
            <ng-template #caption>
              <div class="flex align-items-center">
                <div>
                  <h5 class="mb-0">{{ 'groups.users.title' | translate }}</h5>
                </div>
                <p-iconfield iconPosition="left" class="ml-auto">
                  <p-inputicon>
                    <i class="pi pi-search"></i>
                  </p-inputicon>
                  <input
                    pInputText
                    type="text"
                    (input)="filterGroupUsers($event, groupUsersTable)"
                    [placeholder]="'groups.users.search.placeholder' | translate"
                    class="w-full max-w-sm"
                  />
                </p-iconfield>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="username">
                  {{ 'groups.users.table.username' | translate }}
                  <p-sortIcon field="username"></p-sortIcon>
                </th>
                <th pSortableColumn="firstName">
                  {{ 'groups.users.table.firstName' | translate }}
                  <p-sortIcon field="firstName"></p-sortIcon>
                </th>
                <th pSortableColumn="lastName">
                  {{ 'groups.users.table.lastName' | translate }}
                  <p-sortIcon field="lastName"></p-sortIcon>
                </th>
                <th pSortableColumn="role">
                  {{ 'groups.users.table.role' | translate }}
                  <p-sortIcon field="role"></p-sortIcon>
                </th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-user>
              <tr>
                <td>{{ user.username }}</td>
                <td>{{ user.firstName }}</td>
                <td>{{ user.lastName }}</td>
                <td>{{ user.role }}</td>
                <td>
                  <div class="flex">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-ellipsis-v"
                      class="p-button-text p-button-sm"
                      (click)="userMenu.toggle($event)"
                    ></button>

                    <p-menu
                      #userMenu
                      [popup]="true"
                      [model]="groupUserMenuItems"
                      [appendTo]="'body'"
                      [baseZIndex]="1000"
                      styleClass="custom-menu"
                      (onShow)="onShowUserMenu(group, user)"
                    ></p-menu>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="text-center">
                  {{ 'groups.users.empty' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center">
          {{ 'groups.empty' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
